import script from "./StepBenefit.vue?vue&type=script&setup=true&lang=js"
export * from "./StepBenefit.vue?vue&type=script&setup=true&lang=js"

import "./StepBenefit.vue?vue&type=style&index=0&id=1665865e&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1665865e"]])

export default __exports__